// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddNewContent_wrapper___-SIj","iconBlock":"AddNewContent_iconBlock__1GNWj","plus":"AddNewContent_plus__1EK6p","icon":"AddNewContent_icon__lyDoh"};